import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import PdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?worker&inline";

const PDFJS_VERSION = import.meta.env.VITE_PDFJS_VERSION;

function getPdfJsAssetsBaseUrl() {
  const baseUrl = import.meta.env.BASE_URL || "/";

  if (typeof window === "undefined") {
    return `${baseUrl}pdfjs/${PDFJS_VERSION}/`;
  }

  return new URL(`${baseUrl}pdfjs/${PDFJS_VERSION}/`, window.location.origin).href;
}

function setupPdfWorker() {
  if (typeof window !== "undefined" && !GlobalWorkerOptions.workerPort) {
    GlobalWorkerOptions.workerPort = new PdfWorker();
  }
}

type PdfDocumentOptions = Pick<
  Extract<Parameters<typeof getDocument>[0], { cMapUrl?: string }>,
  | "wasmUrl"
  | "iccUrl"
  | "cMapPacked"
  | "cMapUrl"
  | "standardFontDataUrl"
  | "isImageDecoderSupported"
  | "isOffscreenCanvasSupported"
  | "useWasm"
>;

const PDFJS_ASSETS_BASE_URL = getPdfJsAssetsBaseUrl();

export const PDFJS_DOCUMENT_OPTIONS: PdfDocumentOptions = {
  wasmUrl: `${PDFJS_ASSETS_BASE_URL}wasm/`,
  iccUrl: `${PDFJS_ASSETS_BASE_URL}iccs/`,
  cMapPacked: true,
  cMapUrl: `${PDFJS_ASSETS_BASE_URL}cmaps/`,
  standardFontDataUrl: `${PDFJS_ASSETS_BASE_URL}standard_fonts/`,
  isImageDecoderSupported: false,
  isOffscreenCanvasSupported: false,
  useWasm: true,
};

export function initPdfJs() {
  setupPdfWorker();
}
